import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

import EmployeeChangeImpactsContainer from '../../containers/employees/EmployeeChangeImpactsContainer.jsx';

const EmployeeChangeImpacts = ({ slug, employeeId, search }) => (
  <>
    <Helmet>
      <title>Employee Profile | ChangeSync</title>
    </Helmet>
    <EmployeeChangeImpactsContainer
      slug={slug}
      employeeId={employeeId}
      search={search}
    />
  </>
);

EmployeeChangeImpacts.getInitialProps = ({ query }) => ({
  slug: query.slug,
  employeeId: Number(query.employeeId),
  search: query.search || '',
});

export default requireAuth(withRouterParams(EmployeeChangeImpacts));
